import locationsService from "../../services/locationsService";
import locationActionTypes from "../types/locationActionTypes";

export const getLoactions = () => async (dispatch) => {
    try {
        dispatch({ type: locationActionTypes.START_GET_LOCATION });

        var response = await locationsService.getLoactions();
        dispatch({ type: locationActionTypes.GET_LOCATION_SUCCESS, payload: response.data.payload });

    } catch (error) {
        dispatch({
            type: locationActionTypes.GET_LOCATION_FAILURE,
            payload: error
        });
    }
};

export const addLocation = (data) => async (dispatch) => {
    try {
        dispatch({ type: locationActionTypes.START_ADD_LOCATION });

        await locationsService.addLocation(data);
        dispatch({ type: locationActionTypes.ADD_LOCATION_SUCCESS });

    } catch (error) {
        dispatch({
            type: locationActionTypes.ADD_LOCATION_FAILURE,
            payload: error
        });
    }
};

export const deleteLocation = (data) => async (dispatch) => {
    try {
        dispatch({ type: locationActionTypes.START_DELETE_LOCATION });

        await locationsService.deleteLocation(data);
        dispatch({ type: locationActionTypes.DELETE_LOCATION_SUCCESS });

    } catch (error) {
        dispatch({
            type: locationActionTypes.DELETE_LOCATION_FAILURE,
            payload: error
        });
    }
};

const locationActions = {
    getLoactions,
    addLocation,
    deleteLocation
}
export default locationActions;